import { queryOptions, useQuery } from '@tanstack/react-query';
import { env } from 'config/env';
import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { http, HttpResponse } from 'msw';

import { CurrentSubscription } from 'types/api';

type GetCurrentSubscriptionResponse = {
    current_subscription: CurrentSubscription;
};

export const getCurrentSubscription =
    async (): Promise<CurrentSubscription> => {
        const response = await api.get<
            GetCurrentSubscriptionResponse,
            GetCurrentSubscriptionResponse
        >('/app/api/v1/current_subscription');
        return response.current_subscription;
    };

export const getCurrentSubscriptionQueryOptions = () => {
    return queryOptions({
        queryKey: ['current-subscription'],
        queryFn: () => getCurrentSubscription(),
    });
};

type UseCurrentSubscriptionOptions = {
    queryConfig?: QueryConfig<typeof getCurrentSubscriptionQueryOptions>;
};

export const useCurrentSubscription = ({
    queryConfig,
}: UseCurrentSubscriptionOptions = {}) => {
    return useQuery({
        ...getCurrentSubscriptionQueryOptions(),
        ...queryConfig,
    });
};

export const getCurrentSubscriptionMSWHandler = (
    currentSubscription: CurrentSubscription,
) => {
    return http.get(`${env.API_URL}/app/api/v1/current_subscription`, () => {
        return HttpResponse.json({
            current_subscription: currentSubscription,
        });
    });
};
